import { PrintConfirmationDialog, PrintConfirmationDialogWrapperProps } from './PrintConfirmationDialog';
import { useIptorTranslation } from '@iptor/base';

export const Invoicing = ({ open, handleClose, selectedRows, onSuccess }: PrintConfirmationDialogWrapperProps) => {
  const { t } = useIptorTranslation();
  return (
    <PrintConfirmationDialog
      open={open}
      handleClose={handleClose}
      title={t('sales_orders:Invoicing')}
      selectedRows={selectedRows || []}
      documentType={'invoice'}
      onSuccess={onSuccess}
    />
  );
};
